import { useTypedDispatch } from "@/redux/helpers/hooks.ts";
import axios from "axios";
import { getCart } from "@/redux/slices/user/thunks/getCart.ts";
import { TBillingInterval } from "@/redux/slices/user/types";

const useAddPlan = () => {
  const dispatch = useTypedDispatch();

  return async ({
    planId,
    quantity,
    billing_interval,
  }: {
    planId: number;
    quantity: number;
    billing_interval: TBillingInterval;
  }) =>
    await axios
      .post("/svc/cart/plan", {
        plan_id: planId,
        quantity,
        billing_interval: billing_interval,
      })
      .catch((err) => false)
      .then(async () => {
        return await dispatch(getCart());
      });
};

const useUpgradePlan = () => {
  const dispatch = useTypedDispatch();

  return async ({
    planId,
    quantity,
    billing_interval,
  }: {
    planId: number;
    quantity: number;
    billing_interval: string;
  }) =>
    await axios
      .put("/svc/cart/plan", {
        plan_id: planId,
        quantity,
        billing_interval: billing_interval,
      })
      .catch((err) => false)
      .then(async () => {
        return await dispatch(getCart());
      });
};

export { useAddPlan, useUpgradePlan };
